import React from "react";
import { Box, Paper, Typography } from "@mui/material";

import { Usage } from "fond/types";

import InsightsOverview from "../InsightsOverview/InsightsOverview";

interface InsightsPageProps {
  subscriptionUsage?: Usage;
}

const InsightsPage: React.FC<InsightsPageProps> = ({ subscriptionUsage }: InsightsPageProps) => {
  return (
    <Box>
      <Typography variant="h2">Analytics</Typography>
      <Box pt={4}>
        <Paper elevation={1} data-testid="insights-analytics">
          <InsightsOverview subscriptionUsage={subscriptionUsage} />
        </Paper>
      </Box>
    </Box>
  );
};

export default InsightsPage;
